import SsnVerification from 'features/signup/SsnVerification/SsnVerification';
import React from 'react';

export default function Page() {
  return <SsnVerification />;
}
